module.exports = __webpack_public_path__ + "img/minus.5fce7de7.svg";